// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3_gpr","col":"Table_col__17kED","fulfillmentStatus":"Table_fulfillmentStatus__OCcFj","emailCol":"Table_emailCol__14ZAJ"};